// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from './ui';

export default function ProtectedRoute({ children, roles }) {
  const { user, isBooting } = useAuth();

  // Wait until boot finishes (silent refresh / session restore)
  if (isBooting) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0f1a14]">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 bg-gradient-to-br from-[#1e9f6b] to-[#0d7a52] rounded-2xl flex items-center justify-center shadow-lg animate-pulse">
            <span className="material-symbols-outlined text-white text-[24px]">local_fire_department</span>
          </div>
          <Spinner size="md" />
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/main" replace />;
  }

  return children;
}
